import React, { useState, useEffect } from 'react'
import Page from '../../components/page/page'
import Footer from '../../components/footer/footer.jsx'
import PageContentMargin from '../../components/page-content-margin/page-content-margin'
import ClassList from './class-list'
import Card from '../../components/card/card'
import { joinedClazzes } from '../../api/user'
import { getClazzes, joinClazz } from '../../api/clazz'
import { me } from '../../api/user';
import ModalManager from '../../components/modal/modal-manager'
import JoinClassModal from './join-class-modal'
import ClazzFormModal from "../../components/clazz-form-modal/clazz-form-modal"
import Message from '../../components/message/message'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import teacherImg from './card_teachcenter.png';
import styles from './class-card.scss'

const MyClasses = (props) => {
    const [createClassArr, setCreateClassArr] = useState([])
    const [addClassArr, setAddClassArr] = useState([])
    const [user, setUser] = useState([])
    useEffect(() => {
        getAddClassArr()
        // getCreateClassArr()
        getUser()
    }, [])

    const history = useHistory()

    const getUser = async () => {
        const res = await me({}, {quiet: true})
        if(res) setUser(res)
    }

    const teachcenter = {
        cover:`${window.config.staticURL}/cover/content/card_teachcenter.png`,
        name:'前往教学中心'
    }

    const getCreateClassArr = async () => {
        const res = await getClazzes({ page_size: 100 })
        if (res) setCreateClassArr(res.data)
    }
    const getAddClassArr = async () => {
        const res = await joinedClazzes()
        if (res) setAddClassArr(res)
    }
    const handleCreateClass = () => {
        // ModalManager.open(ClazzFormModal, {
        //     onClose: () => { },
        //     onSubmit: getCreateClassArr
        // })
        window.open(`${window.config.baseURL}/teacher/publicize`,'_blank')
    }
    const handleAddClass = () => {
        ModalManager.open(JoinClassModal, {
            onClose: () => { },
            onSetId: async (v) => {
                if (v) {
                    const res = await joinClazz({ clazz_code: v })
                    if (res) {
                        ModalManager.pop()
                        history.push('/class?id=' + res.id)
                    }
                }
            }
        })
    }
    return (
        <Page isModal={true} title={window.L('teach.user.myclass')}>
            <PageContentMargin>
                {user && user.role == 2 ? (
                    <Card title={window.L('teach.user.createclasses')}>
                        <div className={styles.teachcenter} onClick={handleCreateClass}>
                            <img src={teacherImg}/>
                        </div>
                        {/* <img src={teacherImg}></img> */}
                        {/* <ClassList
                            blankTitle={'前往教学中心'}
                            type='create'
                            dataSource={createClassArr}
                            linkUrl={'/teacher/class?id='}
                            onModal={handleCreateClass}
                        /> */}
                        
                    </Card>
                ) : (null)}
                <Card title={window.L('teach.user.addclasses')}>
                    <ClassList
                        blankTitle={window.L('teach.user.addclass')}
                        type='add'
                        dataSource={addClassArr}
                        linkUrl={'/class?id='}
                        onModal={handleAddClass}
                    />
                </Card>
            </PageContentMargin>
            <Footer />
        </Page>

    )
}

const mapStateToProps = state => {
    return {
        user: state.teach.user
    }
}

export default connect(mapStateToProps, () => { })(MyClasses)
